import { capitalized } from "@/lib/utils";
import { useEffect, useState, memo } from "react";
import { BarChart, Bar, XAxis, ResponsiveContainer, LabelList, Cell, Legend } from "recharts";

function PromotersCard(props) {
    const [data, setData] = useState([]);

    useEffect(() => {
        const dataArray = props.data !== "" && props.data.slice(0, 5).reverse();
        const promotersData = [];
        dataArray?.length > 0 &&
            dataArray.forEach((element, i) => {
                promotersData.push({
                    quarter: element.quarter,
                    promoters: element.promoters,
                    pledges: element.pledges
                });
            });
        setData(promotersData);
    }, [props]);

    const processedData = data.map((item) => ({
        ...item,
        // promoters: 0,
        // pledges: 3,
        dummyPromoters: Math.abs(item.promoters) * 0.02,
        dummyPledges: Math.abs(item.pledges) * 0.02
    }));

    const renderCustomLegend = (props) => {
        const { payload } = props;
        return (
            <ul className="flex">
                {payload
                    .filter((entry) => entry.value !== "dummyPromoters" && entry.value !== "dummyPledges")
                    .map((entry, index) => (
                        <li key={`item-${index}`} className="flex items-center mr-4">
                            <svg width="10" height="10" className="mr-1">
                                <rect
                                    width="10"
                                    height="10"
                                    rx="2"
                                    ry="2"
                                    fill={entry.value === "promoters" ? "#2ACF56" : "#F00"}
                                />
                            </svg>
                            <span className="text-xs font-medium">
                                {capitalized(entry.value) === "Promoters" ? "Promoters" : "Pledged"}
                            </span>
                        </li>
                    ))}
            </ul>
        );
    };

    return (
        <div className="mx-3 rounded-xl font-Inter font-medium">
            {processedData?.filter((f) => f?.promoters > 0)?.length > 0 ? (
                <ResponsiveContainer width="100%" height={228}>
                    <BarChart data={processedData} margin={{ top: 20, right: 0, left: 0, bottom: 8 }}>
                        <XAxis
                            axisLine={false}
                            tickLine={false}
                            dataKey="quarter"
                            tick={{
                                color: "#979797"
                            }}
                            tickMargin={16}
                            interval={0}
                            className="font-Inter font-semibold text-xs"
                        />
                        <Legend content={renderCustomLegend} verticalAlign="top" align="left" height={36} />

                        <Bar dataKey="promoters" stackId="a" radius={[2, 2, 0, 0]}>
                            {processedData.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={`url(#promoters-color-green)`} />
                            ))}
                            <LabelList
                                dataKey="promoters"
                                position="top"
                                content={({ x, y, width, height, value }) => (
                                    <text
                                        x={x + width / 2}
                                        y={y}
                                        dy={-7}
                                        fill={value >= 0 ? "black" : "#DD2C2C"}
                                        fontSize={12}
                                        fontFamily="'Inter', 'sans-serif'"
                                        fontWeight="semibold"
                                        textAnchor="middle"
                                    >
                                        {value}%
                                    </text>
                                )}
                            />
                        </Bar>
                        <Bar dataKey="dummyPromoters" stackId="a" fill="#2ACF56" barSize={2} />
                        {processedData?.filter((f) => f?.pledges > 0)?.length > 0 && (
                            <>
                                <Bar dataKey="pledges" stackId="b" radius={[2, 2, 0, 0]}>
                                    {processedData.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={`url(#promoters-color-red)`} />
                                    ))}
                                    <LabelList
                                        dataKey="pledges"
                                        position="top"
                                        content={({ x, y, width, height, value }) => (
                                            <text
                                                x={x + width / 2}
                                                y={y}
                                                dy={-7}
                                                fill={value >= 0 ? "black" : "#DD2C2C"}
                                                fontSize={10}
                                                fontFamily="'Inter', 'sans-serif'"
                                                fontWeight="semibold"
                                                textAnchor="middle"
                                            >
                                                {value}%
                                            </text>
                                        )}
                                    />
                                </Bar>
                                <Bar dataKey="dummyPledges" stackId="b" fill="#F00" barSize={2} />
                            </>
                        )}
                        <defs>
                            <linearGradient
                                id="promoters-color-green"
                                xmlns="http://www.w3.org/2000/svg"
                                x1="0"
                                y1="0"
                                x2="0"
                                y2="100%"
                                spreadMethod="reflect"
                            >
                                <stop offset="0" stopColor="#BFF1CC" stopOpacity="1" />
                                <stop offset="1" stopColor="#F0FCF3" stopOpacity="1" />
                            </linearGradient>
                            <linearGradient
                                id="promoters-color-red"
                                xmlns="http://www.w3.org/2000/svg"
                                x1="0"
                                y1="0"
                                x2="0"
                                y2="100%"
                                spreadMethod="reflect"
                            >
                                <stop offset="0" stopColor="#FFB2B2" stopOpacity="1" />
                                <stop offset="1" stopColor="#FFF4F4" stopOpacity="1" />
                            </linearGradient>
                        </defs>
                    </BarChart>
                </ResponsiveContainer>
            ) : (
                <div className="h-[228px] flex items-center justify-center">
                    <div className="text-xs font-semibold px-3 py-2 border text-center rounded-lg w-full">
                        No promoters holdings
                    </div>
                </div>
            )}
        </div>
    );
}

function isEqual(prevProps, nextProps) {
    return prevProps.number === nextProps.number;
}

const MemoizedPromotersCard = memo(PromotersCard, isEqual);
export default MemoizedPromotersCard;
